import { render, staticRenderFns } from "./block-insured.vue?vue&type=template&id=1132bd16&scoped=true&"
import script from "./block-insured.vue?vue&type=script&lang=js&"
export * from "./block-insured.vue?vue&type=script&lang=js&"
import style0 from "./block-insured.vue?vue&type=style&index=0&id=1132bd16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132bd16",
  null
  
)

export default component.exports